import React from 'react';
import { COLORS, Color } from '../../../styles/variables';

interface CabrioletDefaultIconProps {
  color?: Color;
}

const CabrioletDefaultIcon: React.FC<CabrioletDefaultIconProps> = ({ color = COLORS.black }) => (
  <svg width="76" height="38" viewBox="0 0 76 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_816_45140)">
      <path
        d="M70.8 17.28L68.41 17.43C68.3699 17.4322 68.3312 17.4444 68.297 17.4654C68.2629 17.4865 68.2347 17.5158 68.2148 17.5506C68.1949 17.5854 68.184 17.6246 68.1832 17.6647C68.1823 17.7048 68.1916 17.7444 68.21 17.78C68.4299 18.1941 68.6236 18.6216 68.79 19.06C68.8054 19.1109 68.8375 19.1553 68.8809 19.1861C68.9244 19.2168 68.9768 19.2323 69.03 19.23C69.65 19.23 71.1 19.05 71.1 19.05"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M12.43 20.57C12.0216 21.0545 11.6505 21.5693 11.32 22.11C11.301 22.1494 11.2711 22.1826 11.2339 22.2056C11.1967 22.2286 11.1538 22.2406 11.11 22.24C10.27 22.24 8.24003 22.3 8.11003 22.24C7.98003 22.18 7.84003 21.47 8.11003 21.24C8.38003 21.01 9.01999 20.24 12.31 20.13C12.3605 20.1326 12.4089 20.151 12.4483 20.1827C12.4877 20.2144 12.516 20.2578 12.5293 20.3065C12.5426 20.3553 12.5402 20.4071 12.5224 20.4544C12.5045 20.5017 12.4722 20.5422 12.43 20.57Z"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M34.03 11.36C30.6866 12.8439 27.452 14.5615 24.35 16.5C24.2632 16.5643 24.1581 16.5993 24.05 16.6C14.74 16.88 10.22 18.12 7.59003 19.55C6.63873 19.9939 5.83406 20.7003 5.27069 21.5861C4.70732 22.4719 4.40866 23.5002 4.40997 24.55C4.32617 25.674 4.36316 26.8038 4.52008 27.92C4.75008 28.58 10.28 29.04 10.28 29.04"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M64.6699 28.11C66.8265 27.982 68.9717 27.7047 71.09 27.28C72.55 26.8 72.51 23.82 72.51 22.92C72.51 22.02 71.71 21.68 71.51 21.51C71.31 21.34 71.3099 20.18 71.1799 19.51C71.2463 18.3271 70.961 17.151 70.36 16.13C69.46 14.8 56.9499 15.21 49.3099 15.54L47.12 15.64C47.06 15.64 46.9799 15.5 46.9099 15.3C46.8422 15.0946 46.7921 14.8838 46.76 14.67C46.7107 14.3578 46.5402 14.0777 46.2855 13.8904C46.0309 13.7032 45.7126 13.624 45.3999 13.67C44.7499 13.67 44.7399 14.25 44.6699 15C44.6628 15.3957 44.6964 15.7911 44.77 16.18H42.77C39.62 16.25 30.62 16.44 29.52 16.44"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M25.97 28.97L49.74 28.74" stroke={color} strokeWidth="0.75" strokeMiterlimit="10" />
      <path
        d="M23.2099 27.32C23.2703 28.3415 23.0255 29.358 22.5068 30.2401C21.9881 31.1222 21.2187 31.8302 20.2966 32.274C19.3745 32.7178 18.3412 32.8774 17.3282 32.7325C16.3152 32.5876 15.3682 32.1447 14.6075 31.4602C13.8468 30.7757 13.3068 29.8805 13.0561 28.8883C12.8055 27.8961 12.8554 26.8518 13.1998 25.8881C13.5441 24.9245 14.1673 24.085 14.99 23.4763C15.8126 22.8677 16.7977 22.5174 17.8199 22.47C19.0696 22.4091 20.2988 22.8035 21.2799 23.58"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M62.3199 27.32C62.383 28.4919 62.0423 29.6501 61.3546 30.6012C60.6669 31.5523 59.6739 32.2389 58.5413 32.5463C57.4086 32.8538 56.2048 32.7636 55.1306 32.2907C54.0564 31.8179 53.1768 30.991 52.6385 29.948C52.1003 28.905 51.9361 27.709 52.1731 26.5596C52.4101 25.4101 53.034 24.3766 53.9409 23.6316C54.8478 22.8866 55.9826 22.475 57.1562 22.4656C58.3299 22.4563 59.4713 22.8496 60.39 23.58"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_816_45140">
        <rect width="68.88" height="22.02" fill="white" transform="translate(4 11)" />
      </clipPath>
    </defs>
  </svg>
);

export default CabrioletDefaultIcon;
